import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propNumber } from '../../../../helpers/custom-prop-types';
const SolutionPdfImageCount = (props) => {
    const { pdfImageCount } = props;
    if (!pdfImageCount) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'ui-solution-pdf-image-count' }, { children: [_jsx("span", { children: "\u8CC7\u6599\u63B2\u8F09\u679A\u6570\uFF1A" }), _jsx("span", Object.assign({ className: 'count-number' }, { children: pdfImageCount })), _jsx("span", { children: "\u30DA\u30FC\u30B8" })] })));
};
SolutionPdfImageCount.propTypes = {
    pdfImageCount: propNumber(),
};
SolutionPdfImageCount.defaultProps = {
    pdfImageCount: null,
};
export default SolutionPdfImageCount;
